import { render, staticRenderFns } from "./ChatGPTDetail.vue?vue&type=template&id=c6fcaf7e&scoped=true&"
import script from "./ChatGPTDetail.vue?vue&type=script&lang=js&"
export * from "./ChatGPTDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChatGPTDetail.vue?vue&type=style&index=0&id=c6fcaf7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fcaf7e",
  null
  
)

export default component.exports